import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import ChatWindow from './ChatWindow';
import TopFilterBar from './TopFilterBar';
import { MessagingProvider } from '../../../features/messaging/MessagingContext';
import './_messaging.scss';

const WhatsAppLayout = () => {
    return (
        <MessagingProvider>
            <Container fluid className="messaging-layout p-0 bg-light">
                <TopFilterBar />
                <div className="messaging-inner-container p-3">
                    <Row noGutters className="h-100 shadow-lg border rounded-lg overflow-hidden bg-white rounded-xl">
                        {/* Left Sidebar */}
                        <Col md={4} lg={3} className="border-right d-flex flex-column h-100 shadow-sm">
                            <Sidebar />
                        </Col>

                        {/* Right Chat Window */}
                        <Col md={8} lg={9} className="bg-messaging h-100 relative">
                            <ChatWindow />
                        </Col>
                    </Row>
                </div>
            </Container>
        </MessagingProvider>
    );
};

export default WhatsAppLayout;
